import { ref } from "vue";

/**Состояние модального окна */
export const useModal = () => {
  /**Видимость */
  const visible = ref(false);
  /**Открыть */
  const open = () => {
    visible.value = true;
  };
  /**Закрыть */
  const close = () => {
    visible.value = false;
  };

  return { visible, open, close };
};
